import api from '@/services/api/api'

class ArtworkService {
  getArtwork (artworkId) {
    return api.get('artwork', {
      params: {
        artworkId: artworkId
      } }).then(result => {
      return result.data
    })
  }
  saveArtwork (artwork) {
    return api.post('artwork/save', artwork).then((response) => {
      if (!response || !response.data) {
        return Promise.reject(response)
      }
      artwork.id = response.data
    })
  }
  deleteArtwork (artwork) {
    return api.delete('artwork/' + artwork.id)
  }
  getArtworkIdByIdentification (identification) {
    return api.get('artwork/get-artwork-id-by-identification', {
      params: {
        identification: identification
      } }).then((response) => {
      if (!response || !response.data) {
        return Promise.reject(response)
      }

      return response.data
    })
  }
}

export default new ArtworkService()



// WEBPACK FOOTER //
// ./src/services/artwork/ArtworkService.js